import React, { useEffect, useState, useRef } from 'react'
// import { useLocation } from 'react-router-dom'
import axios from '../../store/axios-secure'
import styled from 'styled-components'
import { Modal, Button } from 'react-bootstrap'
// import { allUsersRoute, host } from "../utils/APIRoutes";
// import { useNavigate } from "react-router-dom";
import ChatContainer from './ChatContainer'
import Contacts from './Contacts'
// import { BsDot } from "react-icons/bs";
// import { RxDotFilled } from "react-icons/rx";
import { FaCircle } from 'react-icons/fa'
import { BsChatText } from 'react-icons/bs'
import Badge from '@mui/material/Badge'
import dashboardTone from '../../assets/tone/dashboardTone.mp3'
const dashboardAudio = new Audio(dashboardTone)
import BroadcastContainer from './BroadcastContainer'
import io from 'socket.io-client'

// import Welcome from './Welcome'
// import './ChatBoxModal.css'
// import { io } from "socket.io-client";
// import io from 'socket.io-client'
// const socket = io('http://localhost:5000') // Connect to your server's URL
// const socket = io('http://localhost:5000', {
//     query: {
//         userId: 'yourUserIdHere', // Pass the userId as a query parameter
//     },
// });

// const socket = io(process.env.REACT_APP_BASE_URL, { path: '/s2/socket.io' })
import ReactDOM from 'react-dom'
import { fontWeight, textAlign } from '@mui/system'
let path =
    process.env.REACT_APP_MAIN_APPLICATION_CONTEXT_PATH == '/'
        ? '/'
        : process.env.REACT_APP_MAIN_APPLICATION_CONTEXT_PATH
path = path + 'socket.io'
const socket = io(process.env.REACT_APP_BASE_URL, {
    path: path,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    withCredentials: true, // Ensure credentials are sent
})
const CONNECTED_EVENT = 'connected'
const DISCONNECT_EVENT = 'disconnect'

export default function ChatBoxModal({
    clients,
    contacts,
    setClients,
    setContacts,
    isOpen,
    onClose,
    updateContacts,
    // socket,
    trainerId,
}) {
    // const socket = useRef();
    const Logo =
        'https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/brand/EvolvLogo.png'
    const [currentChat, setCurrentChat] = useState(undefined)
    const [currentUser, setCurrentUser] = useState(undefined)
    const [showConts, setShowConts] = useState(false)
    const [isConnected, setIsConnected] = useState(false) // For tracking socket connection
    // const [showChatContaier, setShowChatContainer] = useState(true);

    // const [contacts, setContacts] = useState(contacts);
    // const [clients, setClients] = useState(clients);
    const [messages, setMessages] = useState([]) //n
    //const [showPopup, setShowPopup] = useState(false) //n
    const [hasUnreadMsg, setHasUnreadMsg] = useState(false)
    //const [selectedChat, setSelectedChat] = useState('')
    const [currentSelected, setCurrentSelected] = useState(undefined)
    const [isOnline, setIsOnline] = useState(false)
    const [totalUnreadMessages, setTotalUnreadMessages] = useState(0)
    const [totalUnreadContacts, setTotalUnreadContacts] = useState(0)
    const [isReactionMsg, setIsReactionMsg] = useState(false)
    const prevCurrentChatRef = useRef()
    const [showBroadCastPage, setShowBroadCastPage] = useState(false)
    const [selectedBrodcastFilter, setSelectedBroadcastFilter] =
        useState('my active clients')
    const [broadcastFilteredClients, setBroadcastFilteredClients] = useState([])
    const [exceptOrOnlyClients, setExceptOrOnlyClients] = useState([])

    const handleBroadcastMessage = async (msg) => {
        try {
            let clientList = []
            if (selectedBrodcastFilter == 'active clients except') {
                let broadcastUserRefs = broadcastFilteredClients.map(
                    (client) => client.userRef,
                )
                clientList = broadcastUserRefs.filter(
                    (userRef) => !exceptOrOnlyClients.includes(userRef),
                )
            } else if (selectedBrodcastFilter == 'only share with') {
                clientList = exceptOrOnlyClients
            } else {
                let broadcastUserRefs = broadcastFilteredClients.map(
                    (client) => client.userRef,
                )
                clientList = broadcastUserRefs
            }

            // if (msg.trim() === '' && attachedFiles?.length < 1) {
            //     return
            // }
            if (msg.trim() === '' || clientList.length < 1) {
                return
            }
            const senderType = 'trainer'
            const formData = new FormData()
            formData.append('content', msg)
            formData.append('senderType', senderType)
            formData.append('clientList', JSON.stringify(clientList))
            // attachedFiles?.forEach((file) => {
            //     formData.append('attachments', file)
            // })

            // setAttachedFiles([])
            console.log('clientList..............', clientList)
            let response = await axios.post(
                `chat/sendBroadcast?trainerId=${trainerId}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                },
            )
            // console.log("response.data....", response.data);
        } catch (error) {
            console.error('Failed to broadcast message', error)
        }
    }

    const onUserMoreMessages = (chatId, msgs) => {
        if (currentChat._id == chatId) {
            setCurrentChat((prevChat) => ({
                ...prevChat,
                messages: [...msgs, ...prevChat.messages],
            }))

            // setMessages((prevMsgs) => [...msgs, ...prevMsgs])
        }

        const updatedContacts = contacts.map((chat) => {
            if (chat._id === chatId) {
                return {
                    ...chat,
                    messages: [...msgs, ...chat.messages],
                }
            }
            return { ...chat }
        })
        setContacts(updatedContacts)
    }

    const onConnect = () => {
        console.log('connected............')
        console.log(
            'currentChat and currentselected.......',
            currentChat,
            currentSelected,
        )
        let Id = trainerId
        let type = 'trainer'
        let room = null
        if (currentChat) {
            room = currentChat?.userRef.toString()
            console.log('current chat room.............', room)
        }
        socket.emit('join_trainerRoom', { Id, type, room: room })
        setIsConnected(true)
    }
    const onDisconnect = () => {
        console.log('dicConnected............')
        setIsConnected(false)
    }
    const onIsOnline = async (data) => {
        console.log('onIsOnline..........................', data)
        setIsOnline(data.status)

        if (data.status === true) {
            let chatId = data.clientId

            if (chatId !== currentChat?.userRef) {
                console.log('Inside different chatId------>', chatId)
                const updatedContacts = contacts.map((chat) => {
                    if (chat.userRef === chatId) {
                        const updatedMessages = chat?.messages?.map(
                            (message, index) => {
                                if (
                                    message?.senderType === 'trainer' &&
                                    !message?.hasReached
                                ) {
                                    console.log('message...', message)
                                    return { ...message, hasReached: true }
                                }
                                return message
                            },
                        )

                        return {
                            ...chat,
                            messages: updatedMessages,
                        }
                    }
                    return { ...chat }
                })
                setContacts(updatedContacts)
            } else {
                console.log('Inside same chatId------>', chatId)

                const updatedMessages = currentChat.messages?.map(
                    (message, index) => {
                        if (
                            // index >= startIndex &&
                            message?.senderType === 'trainer' &&
                            !message?.hasReached
                        ) {
                            console.log('message...', message)
                            return { ...message, hasReached: true }
                        }
                        return message
                    },
                )
                setCurrentChat((prevChat) => ({
                    ...prevChat,
                    messages: [...updatedMessages],
                }))
                const updatedContacts = contacts.map((chat) => {
                    if (chat.userRef === chatId) {
                        return { ...currentChat, messages: updatedMessages }
                    } else {
                        return chat
                    }
                })
                setContacts(updatedContacts)
            }
        }
    }
    const onNewChatByClient = (newChat) => {
        console.log(
            'new chat on dashboard created and started by client....',
            newChat,
        )
        setContacts([newChat, ...contacts])
    }
    const onReactedMessage = (data) => {
        console.log('inside onReactedMessage..........', data)
        setIsReactionMsg(true)
        let chatId = data.clientId
        let msg = data.msg
        console.log('onReactedMessage and chatId', msg, chatId)

        if (chatId !== currentChat?.userRef) {
            console.log('Inside different chatId------>', chatId)
            const updatedContacts = contacts.map((chat) => {
                if (chat.userRef === chatId) {
                    const updatedMessages = chat?.messages?.map(
                        (message, index) => {
                            if (message?._id === msg?._id) {
                                console.log('msg..............', message)
                                // return { ...message, hasRead: true }
                                return msg
                            }
                            return message
                        },
                    )

                    return {
                        ...chat,
                        messages: updatedMessages,
                    }
                }
                return { ...chat }
            })
            setContacts(updatedContacts)
            // setContacts([
            //     updatedContacts.find((chat) => chat.userRef === chatId),
            //     ...updatedContacts.filter((chat) => chat.userRef !== chatId),
            // ])
        } else {
            console.log('Inside same chatId------>', chatId)
            // const lastIndex = messages.length - 1;
            // const startIndex = Math.max(0, lastIndex - 99); // Starting index for the last hundred messages
            const updatedMessages = currentChat?.messages?.map(
                (message, index) => {
                    //checking for recent 100 messages if other party joins it makes hasRead true
                    if (
                        // index >= startIndex &&
                        message?._id == msg?._id
                        // message.text === msg.text
                    ) {
                        console.log('message...|||||||||and msg', message, msg)
                        return msg
                    }

                    return message
                },
            )
            setCurrentChat((prevChat) => ({
                ...prevChat,
                messages: [...updatedMessages],
            }))
            const updatedContacts = contacts.map((chat) => {
                if (chat.userRef === chatId) {
                    return { ...currentChat, messages: updatedMessages }
                } else {
                    return chat
                }
            })
            setContacts(updatedContacts)
        }
    }
    const onAutomatedMsgNotification = (data) => {
        // console.log('onAutomatedMsgNotification......', data)
        let chatId = data.clientId
        let newMessage = data.message
        console.log(
            'newautomatedMsgNotification and chatId',
            newMessage,
            chatId,
        )

        if (chatId !== currentChat?.userRef) {
            console.log('Inside different chatId------>', chatId)
            const updatedContacts = contacts.map((chat) => {
                if (
                    chat.userRef === chatId
                    // &&newMessage.hasRead == false
                ) {
                    return {
                        ...chat,
                        messages: [...chat.messages, newMessage],
                    }
                }
                return { ...chat }
            })
            // setContacts([
            //     updatedContacts.find((chat) => chat.userRef === chatId),
            //     ...updatedContacts.filter((chat) => chat.userRef !== chatId),
            // ])
            let foundChat = updatedContacts.find(
                (chat) => chat.userRef === chatId,
            )
            if (foundChat) {
                // to handle automatedmessages set for newUser when chatRoom is not defined
                setContacts([
                    foundChat,
                    ...updatedContacts.filter(
                        (chat) => chat.userRef !== chatId,
                    ),
                ])
            } else {
                console.log(`No chat found with chatId: ${chatId}`)
            }
        } else {
            // If it belongs to the current chat, update the messages list for the active chat
            console.log('Inside same chatId------>', chatId)
            setMessages((prev) => [...prev, newMessage])
            let currChat = currentChat
            currChat.messages.push(newMessage)
            setCurrentChat(currChat)
            // setReceivedMessage(newMessage)
        }
    }
    const onOtherPartyJoined = (cId) => {
        console.log('onOtherPartyJoined......', cId)
        let chatId = cId

        if (chatId !== currentChat?.userRef) {
            console.log('Inside different chatId------>', chatId)
            const updatedContacts = contacts.map((chat) => {
                if (chat.userRef === chatId) {
                    const updatedMessages = chat?.messages?.map(
                        (message, index) => {
                            if (
                                message?.senderType === 'trainer' &&
                                !message?.hasRead
                            ) {
                                console.log('message...', message)
                                return { ...message, hasRead: true }
                            }
                            return message
                        },
                    )

                    return {
                        ...chat,
                        messages: updatedMessages,
                    }
                }
                return { ...chat }
            })
            setContacts(updatedContacts)
            // setContacts([
            //     updatedContacts.find((chat) => chat.userRef === chatId),
            //     ...updatedContacts.filter((chat) => chat.userRef !== chatId),
            // ])
        } else {
            console.log('Inside same chatId------>', chatId)
            // const lastIndex = messages.length - 1;
            // const startIndex = Math.max(0, lastIndex - 99); // Starting index for the last hundred messages
            const updatedMessages = messages?.map((message, index) => {
                //checking for recent 100 messages if other party joins it makes hasRead true
                if (
                    // index >= startIndex &&
                    message?.senderType === 'trainer' &&
                    !message?.hasRead
                ) {
                    console.log('message...', message)
                    return { ...message, hasRead: true }
                }
                return message
            })
            setCurrentChat((prevChat) => ({
                ...prevChat,
                messages: [...updatedMessages],
            }))
            const updatedContacts = contacts.map((chat) => {
                if (chat.userRef === chatId) {
                    return { ...currentChat, messages: updatedMessages }
                } else {
                    return chat
                }
            })
            setContacts(updatedContacts)
        }
    }
    const onReceiveMessage = (newMessage) => {
        if (newMessage.isBroadcast === true) {
            console.log(
                'for broadcastedMsg Clientlist------>',
                newMessage?.clientList,
            )
            const updatedContacts = contacts.map((chat) => {
                if (
                    // chat.userRef === chatId
                    newMessage.clientList.includes(chat.userRef)
                    // &&newMessage.hasRead == false
                ) {
                    newMessage = { ...newMessage, receiver: chat.userRef }
                    return {
                        ...chat,
                        messages: [...chat.messages, newMessage],
                    }
                }
                return { ...chat }
            })
            setContacts(updatedContacts)
        } else {
            const chatId =
                newMessage.senderType === 'trainer'
                    ? newMessage?.receiver
                    : newMessage?.sender

            if (chatId !== currentChat?.userRef) {
                console.log('Inside different chatId------>', chatId)
                const updatedContacts = contacts.map((chat) => {
                    if (
                        chat.userRef === chatId
                        // &&newMessage.hasRead == false
                    ) {
                        return {
                            ...chat,
                            messages: [...chat.messages, newMessage],
                            unreadMessages: [
                                ...chat.unreadMessages,
                                newMessage,
                            ],
                        }
                    }
                    return { ...chat }
                })
                // setContacts(updatedContacts)
                setContacts([
                    updatedContacts.find((chat) => chat.userRef === chatId),
                    ...updatedContacts.filter(
                        (chat) => chat.userRef !== chatId,
                    ),
                ])
            } else {
                // If it belongs to the current chat, update the messages list for the active chat
                console.log('Inside same chatId------>', chatId)
                setMessages((prev) => [...prev, newMessage])
                let currChat = currentChat
                currChat.messages.push(newMessage)
                setCurrentChat(currChat)

                // setCurrentChat((prevChat) => ({
                //     ...prevChat,
                //     messages: [...updatedMessages],
                // }))
                const updatedContacts = contacts.map((chat) => {
                    if (chat.userRef === chatId) {
                        return { ...currentChat }
                    } else {
                        return chat
                    }
                })
                setContacts(updatedContacts)
                // setReceivedMessage(newMessage)
            }
        }
        if (newMessage.senderType !== 'trainer') {
            dashboardAudio.play() //notification tone
        }
    }
    // useEffect(() => {
    //     if (currentChat) {
    //         const updatedCurrChat = contacts.find((chat) => chat._id == currentChat._id);
    //         if (updatedCurrChat) {
    //             setCurrentChat(updatedCurrChat);
    //         }
    //     }
    // }, [contacts])

    useEffect(() => {
        const checkUnreadMessages = async () => {
            const totalUnreadMessages = contacts.reduce(
                (accumulator, contact) =>
                    accumulator + (contact?.unreadMessages.length || 0),
                0,
            )
            const totalUnreadContacts = contacts.filter(
                (contact) => contact.unreadMessages.length > 0,
            ).length
            setTotalUnreadContacts(totalUnreadContacts)
            setTotalUnreadMessages(totalUnreadMessages)

            setHasUnreadMsg(totalUnreadMessages > 0)
        }

        checkUnreadMessages()
    }, [contacts, currentChat])

    useEffect(() => {
        socket.on('other_party_joined', onOtherPartyJoined)
        // socket.on('is_online', onIsOnline)

        return () => {
            socket.off('other_party_joined', onOtherPartyJoined)
            // socket.off('is_online', onIsOnline)
        }
    }, [messages])

    useEffect(() => {
        socket.on('receive_message', onReceiveMessage)
        socket.on('newChatByClient', onNewChatByClient)
        // socket.on('other_party_joined', onOtherPartyJoined)
        socket.on('automated_MsgNotification', onAutomatedMsgNotification)
        socket.on('is_online', onIsOnline)
        socket.on(CONNECTED_EVENT, onConnect)
        socket.on(DISCONNECT_EVENT, onDisconnect)
        socket.on('reacted_message', onReactedMessage)
        return () => {
            socket.off('receive_message')
            socket.off('is_online', onIsOnline)
            socket.off(CONNECTED_EVENT, onConnect)
            socket.off(DISCONNECT_EVENT, onDisconnect)
            socket.off('newChatByClient', onNewChatByClient)
            socket.off('automated_MsgNotification', onAutomatedMsgNotification)
            socket.off('reacted_message', onReactedMessage)

            // socket.off('other_party_joined', onOtherPartyJoined)
        }
    }, [socket, currentChat, contacts])

    useEffect(() => {
        const areChatsEqual = (chat1, chat2) => {
            return chat1?.userRef === chat2?.userRef
        }
        console.log('inside from dlk................')
        currentChat ? setMessages(currentChat?.messages) : ''
        let clientId = currentChat?.userRef.toString()
        let joinerType = 'trainer'
        if (currentChat) {
            let currChat = currentChat
            currentChat.messages = currentChat.messages.map((msg) => {
                if (
                    msg &&
                    msg?.hasRead == false &&
                    msg.senderType !== 'trainer'
                ) {
                    return { ...msg, hasRead: true }
                } else {
                    return { ...msg }
                }
                // return { ...msg, hasRead: (senderType !== msg.senderType)?true:false };
            })
            if (
                currentChat &&
                !areChatsEqual(currentChat, prevCurrentChatRef.current)
            ) {
                socket.emit('join_room', { clientId, joinerType })
            }

            prevCurrentChatRef.current = currentChat
        }
    }, [currentChat])

    const handleChatChange = (chat) => {
        setCurrentChat(chat)
    }

    const handleClose = () => {
        setCurrentChat(undefined)
        onClose()
    }

    return (
        <>
            {!showConts ? (
                <div
                    className="chat-button"
                    onClick={() => {
                        setShowConts(true)
                    }}
                    style={{
                        position: 'fixed',
                        bottom: '10px',
                        right: '30px',
                        backgroundColor: '#051627',
                        // color: #36f5c7;
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',
                        zIndex: 10000,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
                    }}
                >
                    {totalUnreadContacts > 0 ? (
                        <Badge
                            color="error"
                            sx={{ color: '#36f5c7' }}
                            badgeContent={totalUnreadContacts}
                        >
                            <BsChatText size={30} />
                        </Badge>
                    ) : (
                        <BsChatText size={30} />
                    )}
                </div>
            ) : (
                <Container
                    style={{
                        zIndex: 10000,
                        borderTopLeftRadius: '8px',
                        borderTopRightRadius: '8px',
                    }}
                >
                    <div className="container" style={{ zIndex: 10000 }}>
                        <Contacts
                            contacts={contacts}
                            setContacts={setContacts}
                            changeChat={handleChatChange}
                            clients={clients}
                            setShowConts={setShowConts}
                            setCurrentChat={setCurrentChat}
                            socket={socket}
                            setHasUnreadMsg={setHasUnreadMsg}
                            hasUnreadMsg={hasUnreadMsg}
                            currentSelected={currentSelected}
                            setCurrentSelected={setCurrentSelected}
                            totalUnreadMessages={totalUnreadMessages}
                            setTotalUnreadMessages={setTotalUnreadMessages}
                            totalUnreadContacts={totalUnreadContacts}
                            setTotalUnreadContacts={setTotalUnreadContacts}
                            showBroadCastPage={showBroadCastPage}
                            setShowBroadCastPage={setShowBroadCastPage}
                            broadcastFilteredClients={broadcastFilteredClients}
                            setBroadcastFilteredClients={
                                setBroadcastFilteredClients
                            }
                            selectedBrodcastFilter={selectedBrodcastFilter}
                            setSelectedBroadcastFilter={
                                setSelectedBroadcastFilter
                            }
                            exceptOrOnlyClients={exceptOrOnlyClients}
                            setExceptOrOnlyClients={setExceptOrOnlyClients}
                        />
                        {currentChat === undefined ? null : (
                            <ChatContainer
                                className="chat-container"
                                currentChat={currentChat}
                                setCurrentChat={setCurrentChat}
                                socket={socket}
                                messages={messages}
                                setMessages={setMessages}
                                setCurrentSelected={setCurrentSelected}
                                isConnected={isConnected}
                                isOnline={isOnline}
                                isReactionMsg={isReactionMsg}
                                setIsReactionMsg={setIsReactionMsg}
                                onUserMoreMessages={onUserMoreMessages}
                            />
                        )}
                        {showBroadCastPage && (
                            <BroadcastContainer
                                className="chat-container"
                                socket={socket}
                                currentChat={currentChat}
                                setShowBroadCastPage={setShowBroadCastPage}
                                selectedBrodcastFilter={selectedBrodcastFilter}
                                setSelectedBroadcastFilter={
                                    setSelectedBroadcastFilter
                                }
                                handleBroadcastMessage={handleBroadcastMessage}
                            />
                        )}
                    </div>
                </Container>
            )}
        </>
    )
}

const Container = styled.div`
    right: 0;
    bottom: 0;
    position: fixed;
    border: 1px solid #857c7c69;
    background-color: #101317;
    .container {
        height: 80vh;
        width: 20vw;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        background-color: #101317;
    }
    @media (max-width: 720px) {
        .container {
            width: 100vw;
            height: 100vh;
            .chat-container {
                width: 100vw;
                height: 100vh;
                right: 0;
            }
        }
    }
`
